import React, {useState, useEffect} from 'react'
import {useAuthState} from 'react-firebase-hooks/auth'
import {auth} from './config/firebase'
import ActiveModels from './components/views/modelsList'
import { Header } from '@umahealth/occipital-ui/dist/compat'
import Login from './components/user/login'
import { Button } from '@umahealth/occipital-ui'

function App() {
  const [currentUser, loading] = useAuthState(auth)
  const [bearerToken, setBearerToken] = useState("")

  useEffect(()=> {
    currentUser?.getIdToken()?.then(res => {
      console.log(res)
      setBearerToken(res)})
  }, [currentUser])

  if(loading) return <>Cargando</>

  if(currentUser?.uid) {
    return (
      <div className="App">
        <Header type='service' text='Modelos' />
        <ActiveModels />
        <>{bearerToken}</>
        {/* https://github.com/CSFrequency/react-firebase-hooks/tree/v4.0.2/auth */}
        {/* <Button type='text' action={() => signOut(auth)}>Salir</Button> */}
      </div>
    );
  } else {
    return <Login />
  }
}

export default App;
